import { call, put } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import {
  setDocumentSource
} from '../redux/documentSources'

export default function * fetchDocumentSourceDetails (action) {
  const { id } = action.payload

  yield put(setDocumentSource({
    id,
    isBusy: true
  }))

  try {
    const { IsReadable, Boards } = yield call(apiGetData, 'DocumentsSourceDetailed', {
      id
    })

    const boards = Boards.map(Board => {
      return {
        id: Board.BoardId,
        name: Board.Name,
        isDefault: Board.IsDefault,
        accessDenied: Board.AccessDenied
      }
    })

    yield put(setDocumentSource({
      id,
      isReadable: IsReadable,
      boards,
      isLoaded: true,
      isBusy: false
    }))
  } catch (error) {
    yield put(setDocumentSource({
      id,
      isBusy: false
    }))
  }
}
